var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    {
      style: { flexGrow: 1, position: "relative", marginBottom: 0 },
      attrs: { shrink: "" },
    },
    [
      _c(
        "w-col",
        {
          staticClass: "max-height",
          style: { heigth: "100%", padding: "0 0 0 0" },
          attrs: { xs: "12" },
        },
        [
          _c(
            "w-scroll-view",
            {
              staticClass: "products-table",
              style: { width: "100%" },
              attrs: { id: "products-table", tag: "table", x: "", y: false },
            },
            [
              _c("thead", { staticClass: "head" }, [
                _c("tr", [
                  _c(
                    "th",
                    { staticStyle: { width: "20px" } },
                    [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                    1
                  ),
                  _c(
                    "th",
                    { staticClass: "qty", staticStyle: { width: "80px" } },
                    [_vm._v(" " + _vm._s(_vm.qtyLabel) + " ")]
                  ),
                  _vm.showQty2
                    ? _c(
                        "th",
                        { staticClass: "qty", staticStyle: { width: "120px" } },
                        [_vm._v(" " + _vm._s(_vm.qty2Label) + " ")]
                      )
                    : _vm._e(),
                  _vm.showUnits
                    ? _c(
                        "th",
                        { staticClass: "qty", staticStyle: { width: "80px" } },
                        [_vm._v(" " + _vm._s(_vm.unitLabel) + " ")]
                      )
                    : _vm._e(),
                  _c("th", { staticStyle: { width: "125px" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("sales-row.Sku")) + " "),
                  ]),
                  _vm.state.isPurchaseType
                    ? _c("th", { staticStyle: { width: "125px" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("sales-row.CodeFab")) + " "
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "th",
                    {
                      staticClass: "description",
                      style: {
                        width:
                          "calc(100% - " + _vm.widthWithoutDescription + "px)",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Name")) + " ")]
                  ),
                  _c(
                    "th",
                    { staticClass: "align-r", staticStyle: { width: "122px" } },
                    [_vm._v(" " + _vm._s(_vm.$ct("sales-row.UnitPrice")) + " ")]
                  ),
                  _c(
                    "th",
                    { staticClass: "align-r", staticStyle: { width: "100px" } },
                    [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Discount")) + " ")]
                  ),
                  _c(
                    "th",
                    { staticClass: "align-r", staticStyle: { width: "60px" } },
                    [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Vat")) + " ")]
                  ),
                  _c(
                    "th",
                    { staticClass: "align-r", staticStyle: { width: "122px" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$ct("sales-row.NettoPrice")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "th",
                    { staticClass: "align-r", staticStyle: { width: "122px" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$ct("sales-row.BrutoPrice")) + " "
                      ),
                    ]
                  ),
                  _c("th", { staticStyle: { width: "32px" } }),
                  _c(
                    "th",
                    {
                      style: {
                        width: "38px",
                        paddingTop: "5px",
                        paddingLeft: "7px",
                      },
                    },
                    [
                      _c(
                        "w-dropdown",
                        {
                          staticClass: "dropdown",
                          style: { fontWeight: "normal" },
                          attrs: {
                            items: _vm.options,
                            flat: "",
                            center: "",
                            right: "",
                            "auto-up": "",
                          },
                          on: {
                            click: function ($event) {
                              return $event()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "cog" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "w-scroll-view",
                {
                  ref: "scrollView",
                  staticClass: "body",
                  style: { "overflow-y": "scroll" },
                  attrs: {
                    tag: "w-sortable",
                    "tag-attributes": _vm.sortableAttributes,
                  },
                  nativeOn: {
                    scroll: function ($event) {
                      return _vm.onScroll($event)
                    },
                  },
                },
                [
                  _c("tr", { staticClass: "sortable-ignore" }, [
                    _c("td", {
                      style: {
                        height: `${_vm.beforeHeight}px`,
                        boxSizing: "border-box",
                      },
                      attrs: { colspan: _vm.colCount },
                    }),
                  ]),
                  _vm._l(_vm.renderedRows, function (row, i) {
                    return _c("app-row", {
                      key: i,
                      class: { compact: _vm.compact, full: _vm.full },
                      attrs: {
                        state: _vm.state,
                        "row-index": _vm.renderedRowsStart + i,
                        "show-qty2": _vm.showQty2,
                        "show-units": _vm.showUnits,
                      },
                      on: {
                        "edit-delivery-date": function ($event) {
                          return _vm.editDeliver($event)
                        },
                        "show-image-upload": function ($event) {
                          return _vm.onShowImageUpload($event)
                        },
                      },
                      nativeOn: {
                        contextmenu: function ($event) {
                          return _vm.onCellContextMenu($event)
                        },
                      },
                    })
                  }),
                  _c("tr", { staticClass: "sortable-ignore" }, [
                    _c("td", {
                      style: { height: `${_vm.afterHeight}px` },
                      attrs: { colspan: _vm.colCount },
                    }),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("app-context-menu", {
        attrs: {
          items: _vm.cellContextMenuItems,
          "mouse-x": _vm.cellContextMenu.mouseX,
          "mouse-y": _vm.cellContextMenu.mouseY,
        },
        on: {
          click: function ($event) {
            return _vm.onCellContextMenuClick($event)
          },
        },
        model: {
          value: _vm.cellContextMenu.opened,
          callback: function ($$v) {
            _vm.$set(_vm.cellContextMenu, "opened", $$v)
          },
          expression: "cellContextMenu.opened",
        },
      }),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editDeliveryDate,
            callback: function ($$v) {
              _vm.editDeliveryDate = $$v
            },
            expression: "editDeliveryDate",
          },
        },
        [
          _c("app-sale-row-edit-delivery-date-modal", {
            attrs: { state: _vm.state },
            on: {
              close: function ($event) {
                _vm.editDeliveryDate = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.state.showImageUploadModal,
            callback: function ($$v) {
              _vm.$set(_vm.state, "showImageUploadModal", $$v)
            },
            expression: "state.showImageUploadModal",
          },
        },
        [
          _c("app-sale-edit-row-image", {
            attrs: { state: _vm.state },
            on: {
              file: _vm.onFileInput,
              clear: _vm.onClearImage,
              close: function ($event) {
                _vm.state.showImageUploadModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }